import ConversationStatus from '@/models/Conversations/ConversationStatus';

export default class UpdateConversationStatusRequest {
    status: ConversationStatus;
}